<template>
    <div class="mian">
      <div class="login-container">
        <!-- 左侧内容区 -->
        <div class="left-content">
          <div class="logo-section">
            <img src="@/assets/images/logo2.png" alt="logo" class="logo" />
            <div class="logo-text">
              <div class="logo-title">EC SaaS</div>
              <div class="logo-subtitle">E-CHARGE SERVICE PLATFORM</div>
            </div>
          </div>
          <div class="main-title">
            <div class="title-line1">易充云</div>
            <div class="title-line2">充电运营<span class="title-black">平台</span></div>
          </div>
          <div class="sub-title">一站式充电场站运营管理解决方案</div>
          <div class="sub-title-desc">多租户·全场景·智能化·可视化</div>
          <div class="feature-list">
            <div class="feature-item">
              <img src="@/assets/images/login/icon1.png" alt="icon" class="feature-icon" />
              <div class="feature-text">
                <div class="feature-title">实时数据大屏</div>
                <div class="feature-desc">全维度运营数据可视化监控</div>
              </div>
            </div>
            <div class="feature-item">
              <img src="@/assets/images/login/icon2.png" alt="icon" class="feature-icon" />
              <div class="feature-text">
                <div class="feature-title">多租户架构</div>
                <div class="feature-desc">支持总平台与多级租户独立运营</div>
              </div>
            </div>
            <div class="feature-item">
              <img src="@/assets/images/login/icon3.png" alt="icon" class="feature-icon" />
              <div class="feature-text">
                <div class="feature-title">智能告警系统</div>
                <div class="feature-desc">设备状态实时监测与异常预警</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧登录表单区 -->
        <div class="right-form">
          <div class="form-inner">
            <div class="form-header">
              <div class="welcome-title">欢迎登录</div>
              <img src="@/assets/images/login/line.png" alt="line" class="title-line" />
            </div>
            <el-form label-position="top" class="login-form">
              <el-form-item>
                <el-input v-model="loginInfo.user_id" placeholder="租户编号" prefix-icon="User" autocomplete="user_id" />
              </el-form-item>
              <el-form-item>
                <el-input name="username" v-model="loginInfo.user_name" type="text" @keyup.enter="login" placeholder="请输入账号" prefix-icon="User" autocomplete="username" />
              </el-form-item>
              <el-form-item>
                <el-input v-model="loginInfo.password" type="password" @keyup.enter="login" placeholder="请输入密码" prefix-icon="Lock" autocomplete="off" />
              </el-form-item>
              <el-form-item style="margin-top: 10px;">
                <el-button class="login-btn" type="primary" @click="login()">
                  安全登录
                </el-button>
                <el-button class="apply-btn" style="margin-left: 0px;" type="success" @click="toApply()">
                  入驻申请
                </el-button>
              </el-form-item>
            </el-form>
            <div class="footer-info">
              <div class="copyright">©2026 EC SaaS Platform. All Rights Reserved</div>
              <div class="version">版本V2.0.1  |  技术支持热线:400-808-8053</div>
            </div>
          </div>
        </div>
      </div>

        <el-dialog
            v-model="drawer"
            :title="e_title"
            :width="'1500px'"
            :before-close="handleClose"
            class="join-dialog"
            center
        >
        <div class="join-banner">
          <img src="@/assets/images/login/join_bg.png" alt="banner" class="join-banner-img" />
        </div>
        <div class="join-form-wrapper">
          <div class="join-form-title">填写申请信息</div>
          <el-form :model="signInfo" label-position="right" label-width="140px" class="join-form">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="企业名称" prop="" required>
                  <el-input v-model="signInfo.name" placeholder="请输入企业名称" autocomplete="off" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="法定代表人" prop="" required>
                  <el-input v-model="signInfo.cardName" placeholder="请输入法定代表人" autocomplete="off" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="注册地址" prop="" required>
                  <el-input v-model="signInfo.companyAddress" placeholder="请输入注册地址" autocomplete="off" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="统一社会信用代码" prop="" required>
                  <el-input v-model="signInfo.creditCode" placeholder="请输入统一社会信用代码" autocomplete="off" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="成立日期" prop="" required>
                  <el-date-picker
                      v-model="signInfo.establishDate"
                      type="date"
                      value-format="YYYY-MM-DD"
                      placeholder="请选择成立日期"
                      style="width: 100%;"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="经营范围" prop="" required>
                  <el-input v-model="signInfo.businessScope" placeholder="请输入经营范围" autocomplete="off" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="租户类型" prop="" required>
                  <el-select v-model="signInfo.type" placeholder="请选择租户类型" style="width: 100%;">
                    <el-option
                        v-for="item in tenantTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="租用意向" prop="" required>
                  <el-select v-model="signInfo.rentalType" @change="changeRentalalType" placeholder="请选择租用意向" style="width: 100%;">
                    <el-option
                        v-for="item in rentalTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="租用期限" prop="" required>
                  <el-select v-model="signInfo.rentalTerm" placeholder="请选择租用期限" style="width: 100%;">
                    <el-option
                        v-for="item in rentalTermList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="申请人" prop="" required>
                  <el-input v-model="signInfo.applicantName" placeholder="请输入申请人" autocomplete="off" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="申请人电话" prop="" required>
                  <el-input v-model="signInfo.phone" placeholder="请输入申请人电话" autocomplete="off" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="公司热线" prop="" required>
                  <el-input v-model="signInfo.contactNumber" placeholder="请输入公司热线" autocomplete="off" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="联系邮箱" prop="" required>
                  <el-input v-model="signInfo.email" placeholder="请输入联系邮箱" autocomplete="off" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="租户编码" prop="" required>
                  <el-input v-model="signInfo.code" placeholder="请输入租户编码" autocomplete="off" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-button type="primary" link @click="getCodeTenant" class="generate-code-btn">生成租户编码</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="drawer = false">取消</el-button>
                <el-button type="success" @click="submitApply()">提交申请</el-button>
            </div>
        </template>
        </el-dialog>
      
    </div>
</template>

<script>
import { Base64 } from 'js-base64';
import { ElMessage } from 'element-plus'

export default {
  name:'Mian',
  data() {
    return {
      drawer:false,  //抽屉
      e_title:'申请租用模板',
      tenantTypeList:[
        {
          value:1,
          label:'公司/企业',
        },
        {
          value:2,
          label:'个体工商户',
        },
      ],
      rentalTypeList:[
        {
          value:1,
          label:'月租',
        },
        {
          value:2,
          label:'年租',
        },
      ],
      rentalTermList:[],
      monthList:[
        {
          value:1,
          label:'1个月',
        },
        {
          value:6,
          label:'6个月',
        }
      ],
      yearList:[
        {
          value:12,
          label:'1年',
        },
        {
          value:36,
          label:'3年',
        },
        {
          value:60,
          label:'5年',
        },
      ],
      isSign:false,  //注册/登录
      loginInfo:{
        user_id:'',  //租户ID
        user_name:'', //账号
        password:'',  //密码
      },
      signInfo:{
        name:'',
        type:'',
        rentalTerm:'',
        rentalType:'',
        code:'',
        contactNumber:'',
        email:'',
        certificateUrl:'',
        // merchantAbbreviation:'',
        companyAddress:'',
        // officeAddress:'',
        creditCode:'',
        cardName:'',
        establishDate:'',
        businessScope:'',
        applicantName:'',
        phone:'',
        bankLicense:'',
        cardNo:'44030419900101001X',
      },
    }
  },
  mounted(){
    // console.log(this.$store.state.token);
  },
  methods:{
    submitApply(){
      //提交申请
      let that = this; 
      let param = {};
      param = that.signInfo;
      that.$axios.post("platform-server/tenant/register",JSON.stringify(param)).then(result => {
          if(result.code==200){
              ElMessage.success('提交成功！');
              that.drawer = false;
          }
      })
    },
    getCodeTenant(){
      //获取列表
      let that = this;
      let param = {}; 
      that.$axios.post("platform-server/tenant/code/generate",JSON.stringify(param)).then(result => {
          if(result.code==200){
              that.signInfo.code = result.data;
          }
      })
    },
    changeRentalalType(){
      this.rentalTermList = [];
      this.signInfo.rentalTerm = '';
      if(this.signInfo.rentalType=='1'){
        this.rentalTermList = this.monthList;
      }else{
        this.rentalTermList = this.yearList;
      }
    },
    toApply(){
      this.drawer = true;
    },
    closeAdd(){
      this.drawer = false;
    },
    handleClose(done) {
      this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
      })
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    toHome(){
        this.$router.push('/home');
        // document.title = '首页';
    },
    toLogin(){
      this.isSign = false;
    },
    login(){
      //登录
      let that = this;
      let param = {};
      param.tenantCode = that.loginInfo.user_id;
      param.username = that.loginInfo.user_name;
      param.password = Base64.encode(that.loginInfo.password);
      localStorage.removeItem('token');
      // console.log(param)
      that.$axios.post("gateway/login",param).then(result => {
        if(result.code==200){
          that.$store.state.tenantId = result.data.tenantId;
          localStorage.setItem('tenantId',that.$store.state.tenantId);
          localStorage.setItem('tenantName',result.data.tenantName);
          localStorage.setItem('SAAS_USERNAME',result.data.username);
          localStorage.setItem('provinceCode',result.data.provinceCode || '');
          localStorage.setItem('province',result.data.province || '');
          this.$store.state.token = '';
          this.$store.state.token = this.$store.state.token_base + result.data.token;  //保存token
          localStorage.setItem('token',this.$store.state.token);
          this.$store.state.authority = '';
          this.$store.state.authority = result.data.authority;  //保存authority
          localStorage.setItem('authority',JSON.stringify(this.$store.state.authority));
          this.$router.push('/home');
        }
      })
    },
    toSign(){
      this.isSign = true;
    },
    sign(){
      //注册
      let that = this;
      // console.log(that.signInfo);
      that.$axios.post(that.$store.state.platformApi+"tenant/register",JSON.stringify(that.signInfo)).then(result => {
        ElMessage({
          message: '注册成功',
          type: 'success',
        })
        that.toLogin();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mian{
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background: url('@/assets/images/login_bg.png') no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-container{
    width: 1000px;
    height: 520px;
    display: flex;
    border-radius: 16px;
    overflow: hidden;
    // box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    background: url('@/assets/images/login/content_bg.png') no-repeat;
    background-size: 100% 100%;
    position: relative;

    .left-content{
      width: 100%;
      height: 520px;
      padding: 32px 40px 32px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      position: relative;
      z-index: 2;

      .logo-section{
        display: flex;
        align-items: center;
        margin-bottom: 24px;

        .logo{
          width: 44px;
          height: 44px;
          margin-right: 12px;
        }

        .logo-text{
          .logo-title{
            font-size: 18px;
            font-weight: bold;
            color: #333;
            line-height: 1.3;
          }

          .logo-subtitle{
            font-size: 11px;
            color: #666;
            letter-spacing: 0.5px;
          }
        }
      }

      .main-title{
        margin-bottom: 16px;
        //字间距增大
        letter-spacing: 2.5px;

        .title-line1{
          font-size: 28px;
          font-weight: bold;
          color: #333;
          line-height: 1.3;
        }

        .title-line2{
          font-size: 28px;
          font-weight: bold;
          color: #409eff;
          line-height: 1.3;

          .title-black{
            color: #333;
          }
        }
      }

      .sub-title{
        font-size: 13px;
        // color: #666;
        margin-bottom: 4px;
        letter-spacing: 1px;
      }

      .sub-title-desc{
        font-size: 13px;
        // color: #999;
        margin-bottom: 75px;
        letter-spacing: 1px;
      }

      .feature-list{
        .feature-item{
          display: flex;
          align-items: flex-start;
          margin-bottom: 16px;

          .feature-icon{
            width: 32px;
            height: 32px;
            margin-right: 12px;
            flex-shrink: 0;
          }

          .feature-text{
            .feature-title{
              font-size: 14px;
              font-weight: bold;
              color: #333;
              margin-bottom: 2px;
            }

            .feature-desc{
              font-size: 12px;
              color: #999;
              line-height: 1.4;
            }
          }
        }
      }
    }

    .right-form{
      position: absolute;
      right: 0;
      top: 11px;
      bottom: 15px;
      width: 460px;
      background: url('@/assets/images/login/form_bg.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      z-index: 3;
      border-radius: 0 16px 16px 0;
      overflow: hidden;

      .form-inner{
        padding: 50px 32px 2px;
        display: flex;
        flex-direction: column;
        height: 100%;
        box-sizing: border-box;
      }

      .form-header{
        text-align: center;
        margin-bottom: 4px;

        .welcome-title{
          font-size: 20px;
          font-weight: bold;
          color: #409eff;
          margin-bottom: 6px;
        }

        .title-line{
          width: 60px;
          height: 2px;
          margin: 0 auto;
        }
      }

      .login-form{
        display: flex;
        flex-direction: column;

        :deep(.el-form-item){
          margin-bottom: 10px;
        }

        :deep(.el-input__wrapper){
          background-color: rgba(255, 255, 255, 0.8);
          border-radius: 6px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          padding: 6px 10px;
        }

        :deep(.el-input__inner){
          font-size: 13px;
        }

        .login-btn{
          width: 100%;
          height: 36px;
          font-size: 14px;
          border-radius: 6px;
          margin-bottom: 10px;
          background: linear-gradient(90deg, rgba(36, 138, 255, 0.8) 0%, rgba(34, 124, 227, 0.8) 100%);
          border: none;
        }

        .apply-btn{
          width: 100%;
          height: 36px;
          font-size: 14px;
          border-radius: 6px;
          background: linear-gradient(90deg, rgba(86, 214, 114, 0.8) 0%, rgba(28, 186, 125, 0.8) 100%);
          border: none;
        }
      }

      .footer-info{
        text-align: center;
        margin-top: 6px;

        .copyright{
          font-size: 11px;
          color: #999;
          margin-bottom: 2px;
        }

        .version{
          font-size: 11px;
          color: #999;
        }
      }
    }
  }
}

/* 入驻申请弹窗样式 */
:deep(.join-dialog) {
  .el-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-dialog {
    max-width: 1500px;
    max-height: 865px;
    border-radius: 16px;
    overflow: hidden;
    margin: 0 !important;
  }

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    max-height: calc(865px - 60px);
    overflow-y: auto;
  }

  .join-banner {
    width: 100%;
    margin: 0;
    padding: 0;
    line-height: 0;
    
    .join-banner-img {
      width: 100%;
      height: auto;
      display: block;
      border-radius: 0;
    }
  }

  .join-form-wrapper {
    padding: 24px 32px;

    .join-form-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
      letter-spacing: 2.5px;
    }

    .join-form {
      :deep(.el-form-item__label) {
        font-size: 14px;
        color: #333;
        
        &::before {
          content: '*';
          color: #f56c6c;
          margin-right: 4px;
        }
      }

      :deep(.el-input__wrapper) {
        background-color: #f5f5f5;
        border-radius: 6px;
        box-shadow: none;
      }

      :deep(.el-select) {
        .el-input__wrapper {
          background-color: #f5f5f5;
        }
      }

      .generate-code-btn {
        margin-top: 8px;
      }
    }
  }

  .el-dialog__footer {
    padding: 16px 32px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: center;
    gap: 16px;

    .el-button {
      min-width: 100px;
    }

    .el-button--success {
      background: linear-gradient(90deg, rgba(86, 214, 114, 0.8) 0%, rgba(28, 186, 125, 0.8) 100%);
      border: none;
      color: #fff;
    }
  }
}
</style>